module.exports = __webpack_public_path__ + "static/media/close_navbar.c08b75a1.svg";